import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { AuthLocationState } from './auth-location.state';
import { AuthLocationStore } from './auth-location.store';

@Injectable({providedIn: 'root'})
export class AuthLocationQuery extends QueryEntity<AuthLocationState> {
  constructor(protected readonly store: AuthLocationStore) {
    super(store);
  }
}
